import API from "./index";

export const getCustomer = ({ token }) => {
  return API.get("/customer", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
